import { render, staticRenderFns } from "./GoodsclassBody.vue?vue&type=template&id=3366c6e4&scoped=true"
import script from "./GoodsclassBody.vue?vue&type=script&lang=js"
export * from "./GoodsclassBody.vue?vue&type=script&lang=js"
import style0 from "./GoodsclassBody.vue?vue&type=style&index=0&id=3366c6e4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3366c6e4",
  null
  
)

export default component.exports